//AUTH
export const LOGIN_PAGE_URL = '/auth/login';
export const LOGOUT_PAGE_URL = '/auth/logout';

// INDICE
export const INDEX_PAGE_URL = '/inicio/indice';
export const SOCIAL_NETWORK_PAGE_URL = '/inicio/rede-social';
export const DASHBOARD_PAGE_URL = '/inicio/dashboard';
export const CALENDAR_PAGE_URL = '/inicio/agenda';
export const TELEMETRY_PAGE_URL = '/inicio/telemetria';
export const ADD_CALENDAR_PAGE_URL = '/inicio/agenda/novo';
export const EDIT_CALENDAR_PAGE_URL = (id: string) => `/inicio/agenda/edita/${id}`;
export const SUBSCRIPTION_PAGE_URL = '/inicio/assinatura/detalhes';
export const UPGRADE_PAGE_URL = '/inicio/upgrade-plano';
export const SUPPORT_PAGE_URL = '/suporte';
export const TICKETS_PAGE_URL = '/chamados';
export const TICKET_PAGE_URL = (id: string) => `/chamados/${id}`;
export const ABOUT_PAGE_URL = '/inicio/sobre';

// TREINAMENTOS
export const TRAININGS_PAGE_URL = '/treinamentos';
export const TRAININGS_TEAM_PAGE_URL = '/treinamentos/equipe';
export const TRAINING_COURSE_PAGE_URL = (courseId: string) => `/treinamentos/cursos/${courseId}`;
export const TRAINING_LESSON_PAGE_URL = (courseId: string, lessonId: string) =>
  `/treinamentos/cursos/${courseId}/aulas/${lessonId}`;

//SETUP
export const SETUP_PAGE_URL = '/setup';

// CATALOGO

// Produto
export const PRODUCT_PAGE_URL = '/cadastros/catalogo/produto';
export const PRODUCT_DETAIL_PAGE_URL = (id: string) => `/cadastros/catalogo/produto/${id}`;
export const PRODUCT_LIST_PAGE_URL = '/cadastros/catalogo/produto/lista';
export const PRODUCT_NEW_PAGE_URL = '/cadastros/catalogo/produto/novo';
export const PRODUCT_EDIT_PAGE_URL = (id: string) => `/cadastros/catalogo/produto/edita/${id}`;
export const PRODUCT_REMOVE_PAGE_URL = (id: string) => `/cadastros/catalogo/produto/lista/remove/${id}`;

// Categoria
export const CATEGORY_PAGE_URL = '/cadastros/catalogo/categoria';
export const CATEGORY_DETAIL_PAGE_URL = (id: string) => `/cadastros/catalogo/categoria/${id}`;
export const CATEGORY_LIST_PAGE_URL = '/cadastros/catalogo/categoria/lista';
export const CATEGORY_NEW_PAGE_URL = '/cadastros/catalogo/categoria/lista/novo';
export const CATEGORY_NEW_CHILD_PAGE_URL = (parentId: string) => `/cadastros/catalogo/categoria/lista/novo/${parentId}`;
export const CATEGORY_EDIT_PAGE_URL = (id: string) => `/cadastros/catalogo/categoria/lista/edita/${id}`;
export const CATEGORY_REMOVE_PAGE_URL = (id: string) => `/cadastros/catalogo/categoria/lista/remove/${id}`;
export const CATEGORY_STATUS_PAGE_URL = (id: string) => `/cadastros/catalogo/categoria/lista/status/${id}`;

// Lista de Preço
export const PRICE_LIST_PAGE_URL = '/cadastros/catalogo/lista-de-preco';
export const PRICE_LIST_DETAIL_PAGE_URL = (id: string) => `/cadastros/catalogo/lista-de-preco/${id}`;
export const PRICE_LIST_LIST_PAGE_URL = '/cadastros/catalogo/lista-de-preco/lista';
export const PRICE_LIST_NEW_PAGE_URL = '/cadastros/catalogo/lista-de-preco/novo';
export const PRICE_LIST_EDIT_PAGE_URL = (id: string) => `/cadastros/catalogo/lista-de-preco/edita/${id}`;
export const PRICE_LIST_REMOVE_PAGE_URL = (id: string) => `/cadastros/catalogo/lista-de-preco/lista/remove/${id}`;

// SUPRIMENTOS

// Controle de Estoque
export const STOCK_CONTROL_PAGE_URL = '/suprimentos/estoque';
export const STOCK_CONTROL_INVENTORY_PAGE_URL = '/suprimentos/estoque/lista/inventario';
export const STOCK_CONTROL_MOVEMENT_PAGE_URL = '/suprimentos/estoque/lista/entradas-saidas';
export const STOCK_CONTROL_PRODUCT_PAGE_URL = (id: string) => `/suprimentos/estoque/produto/${id}`;
export const STOCK_CONTROL_LIST_PAGE_URL = '/suprimentos/estoque/lista';
export const STOCK_CONTROL_NEW_PAGE_URL = '/suprimentos/estoque/novo';

// Ordem de Compra
export const PURCHASE_ORDER_PAGE_URL = '/suprimentos/ordem-compra';
export const PURCHASE_ORDER_DETAIL_PAGE_URL = (id: string) => `/suprimentos/ordem-compra/${id}`;
export const PURCHASE_ORDER_LIST_PAGE_URL = '/suprimentos/ordem-compra/lista';
export const PURCHASE_ORDER_EDIT_PAGE_URL = (id: string) => `/suprimentos/ordem-compra/lista/edita/${id}`;
export const PURCHASE_ORDER_REMOVE_PAGE_URL = (id: string) => `/suprimentos/ordem-compra/lista/remove/${id}`;
export const PURCHASE_ORDER_NEW_PAGE_URL = '/suprimentos/ordem-compra/novo';

// Nota de Entrada
export const ENTRY_NOTE_PAGE_URL = '/suprimentos/nota-entrada';
export const ENTRY_NOTE_DETAIL_PAGE_URL = (id: string) => `/suprimentos/nota-entrada/${id}`;
export const ENTRY_NOTE_LIST_PAGE_URL = '/suprimentos/nota-entrada/lista';
export const ENTRY_NOTE_EDIT_PAGE_URL = (id: string) => `/suprimentos/nota-entrada/lista/edita/${id}`;
export const ENTRY_NOTE_REMOVE_PAGE_URL = (id: string) => `/suprimentos/nota-entrada/lista/remove/${id}`;
export const ENTRY_NOTE_NEW_PAGE_URL = '/suprimentos/nota-entrada/novo';

// Picklist
export const PICKLIST_PAGE_URL = '/suprimentos/picklist';
export const PICKLIST_DETAIL_PAGE_URL = (id: string) => `/suprimentos/picklist/${id}`;
export const PICKLIST_LIST_PAGE_URL = '/suprimentos/picklist/lista';
export const PICKLIST_REMOVE_PAGE_URL = (id: string) => `/suprimentos/picklist/lista/remove/${id}`;
export const PICKLIST_NEW_PAGE_URL = '/suprimentos/picklist/novo';
export const PICKLIST_SUPPLY_PAGE_URL = (id: string) => `/suprimentos/picklist/operacao/abastecimento/${id}`;
export const PICKLIST_SUPPLY_CHECK_PAGE_URL = (id: string) =>
  `/suprimentos/picklist/operacao/abastecimento-conferencia/${id}`;

export const CHECKLISTS_PAGE_URL = '/suprimentos/checklists';
export const CHECKLIST_PAGE_URL = (id: string) => `/suprimentos/checklists/${id}`;
export const CHECKLIST_RESPOND_PAGE_URL = (id: string) => `/suprimentos/checklists/${id}/responder`;
export const CHECKLIST_CHECKOUT_PAGE_URL = (id: string) => `/suprimentos/checklists/${id}/finalizar`;

// Operações de inventário
export const INVENTORY_OPERATIONS_PAGE_URL = '/suprimentos/operacoes';
export const INVENTORY_OPERATION_DETAIL_PAGE_URL = (id: string) => `/suprimentos/operacoes/${id}`;

// Conferências de Estoque
export const STOCK_CONFERENCES_PAGE_URL = '/suprimentos/conferencia-estoque';

// Sugestão de compra
export const PURCHASE_SUGGESTION_PAGE_URL = '/suprimentos/sugestao-compra';

// Relatório de Suprimentos
export const SUPPLY_REPORT_PAGE_URL = '/relatorios/suprimentos';
export const SUPPLY_REPORT_STOCK_ENTRY_EXIT_PAGE_URL = '/relatorios/suprimentos/estoque/entrada-saida';
export const SUPPLY_REPORT_STOCK_BALANCE_PAGE_URL = '/relatorios/suprimentos/estoque/saldo';
export const SUPPLY_REPORT_STOCK_NO_CIRCULATION_PAGE_URL = '/relatorios/suprimentos/estoque/sem-circulacao';
export const SUPPLY_REPORT_STOCK_COST_OF_GOODS_SOLD_PAGE_URL =
  '/relatorios/suprimentos/estoque/custo-mercadoria-vendida';
export const SUPPLY_REPORT_ENTRY_NOTE_OPERATION_PAGE_URL = '/relatorios/suprimentos/nota-de-entrada/operacao';
export const SUPPLY_REPORT_ENTRY_NOTE_SUPPLIER_PAGE_URL = '/relatorios/suprimentos/nota-de-entrada/fornecedor';
export const SUPPLY_REPORT_ENTRY_NOTE_PRODUCT_PAGE_URL = '/relatorios/suprimentos/nota-de-entrada/produto';
export const SUPPLY_REPORT_ENTRY_NOTE_EVOLUTION_PAGE_URL = '/relatorios/suprimentos/nota-de-entrada/evolucao';
export const SUPPLY_REPORT_ENTRY_NOTE_PRODUCT_SUPPLIER_PAGE_URL =
  '/relatorios/suprimentos/nota-de-entrada/produto-fornecedor';
export const SUPPLY_REPORT_PURCHASE_ORDER_PAGE_URL = '/relatorios/suprimentos/ordem-de-compra';
export const SUPPLY_REPORT_PRODUCT_LOSS_PAGE_URL = '/relatorios/suprimentos/perda-produto';
export const SUPPLY_REPORT_SHRINKAGE_PAGE_URL = '/relatorios/suprimentos/quebra-acuracidade';

// VENDAS

// Ocorrências
export const OCCURRENCE_PAGE_URL = '/vendas/ocorrencia';
export const OCCURRENCE_DETAIL_PAGE_URL = (id: string) => `/vendas/ocorrencia/${id}`;
export const OCCURRENCE_LIST_PAGE_URL = '/vendas/ocorrencia/lista';
export const OCCURRENCE_NEW_PAGE_URL = '/vendas/ocorrencia/novo';

// Pedido de Venda
export const SALES_ORDER_PAGE_URL = '/vendas/pedido';
export const SALES_ORDER_DETAIL_PAGE_URL = (id: string) => `/vendas/pedido/${id}`;
export const SALES_ORDER_LIST_PAGE_URL = '/vendas/pedido/lista';
export const SALES_ORDER_NEW_PAGE_URL = '/vendas/pedido/novo';
export const SALES_ORDER_EDIT_PAGE_URL = (id: string) => `/vendas/pedido/edita/${id}`;
export const SALES_ORDER_REMOVE_PAGE_URL = (id: string) => `/vendas/pedido/lista/remove/${id}`;

// Planograma
export const PLANOGRAM_PAGE_URL = '/vendas/planograma';
export const PLANOGRAM_DETAIL_PAGE_URL = (id: string) => `/vendas/planograma/${id}`;
export const PLANOGRAM_LIST_PAGE_URL = '/vendas/planograma/lista';
export const PLANOGRAM_NEW_PAGE_URL = '/vendas/planograma/novo';
export const PLANOGRAM_PRODUCT_PAGE_URL = (planogramId: string, productId: string) =>
  `/vendas/planograma/${planogramId}/produto/${productId}`;
export const PLANOGRAM_REMOVE_PAGE_URL = (id: string) => `/vendas/planograma/lista/remove/${id}`;

// Cupons
export const COUPON_PAGE_URL = '/vendas/cupom';
export const COUPON_DETAIL_PAGE_URL = (id: string) => `/vendas/cupom/${id}`;
export const COUPON_LIST_PAGE_URL = '/vendas/cupom/lista';
export const COUPON_NEW_PAGE_URL = '/vendas/cupom/novo';
export const COUPON_EDIT_PAGE_URL = (id: string) => `/vendas/cupom/edita/${id}`;
export const COUPON_REMOVE_PAGE_URL = (id: string) => `/vendas/cupom/lista/remove/${id}`;

// Promoções
export const PROMOTION_PAGE_URL = '/vendas/promocao';
export const PROMOTION_LIST_PAGE_URL = '/vendas/promocao/lista';
export const PROMOTION_NEW_PAGE_URL = '/vendas/promocao/novo';
export const PROMOTION_EDIT_PAGE_URL = (id: string) => `/vendas/promocao/edita/${id}`;
export const PROMOTION_REMOVE_PAGE_URL = (id: string) => `/vendas/promocao/lista/remove/${id}`;

// Nota de Saída
export const OUTGOING_INVOICE_PAGE_URL = '/vendas/nota-saida';
export const OUTGOING_INVOICE_DETAIL_PAGE_URL = (id: string) => `/vendas/nota-saida/${id}`;
export const OUTGOING_INVOICE_LIST_PAGE_URL = '/vendas/nota-saida/lista';
export const OUTGOING_INVOICE_REMOVE_PAGE_URL = (id: string) => `/vendas/nota-saida/lista/remove/${id}`;
export const OUTGOING_INVOICE_NEW_PAGE_URL = '/vendas/nota-saida/novo';
export const OUTGOING_INVOICE_EDIT_PAGE_URL = (id: string) => `/vendas/nota-saida/edita/${id}`;

// Nota Fiscal Consumidor
export const CONSUMER_INVOICE_PAGE_URL = '/vendas/nota-consumidor';
export const CONSUMER_INVOICE_DETAIL_PAGE_URL = (id: string) => `/vendas/nota-consumidor/${id}`;
export const CONSUMER_INVOICE_LIST_PAGE_URL = '/vendas/nota-consumidor/lista';
export const CONSUMER_INVOICE_REMOVE_PAGE_URL = (id: string) => `/vendas/nota-consumidor/lista/remove/${id}`;
export const CONSUMER_INVOICE_NEW_PAGE_URL = '/vendas/nota-consumidor/novo';
export const CONSUMER_INVOICE_EDIT_PAGE_URL = (id: string) => `/vendas/nota-consumidor/edita/${id}`;

// Inutilização Numeração NFCe
export const NFCE_DISABLE_LIST_PAGE_URL = '/vendas/nota-consumidor/inutilizacao/lista';

// Relatório de Vendas
export const SALES_REPORT_PAGE_URL = '/relatorios/vendas';
export const SALES_REPORT_SALES_PAGE_URL = '/relatorios/vendas/geral';
export const SALES_REPORT_ABC_CURVE_PAGE_URL = '/relatorios/vendas/curva-abc';
export const SALES_REPORT_HOURLY_PAGE_URL = '/relatorios/vendas/por-hora';
export const SALES_REPORT_PRODUCT_NOT_FOUND_PAGE_URL = '/relatorios/vendas/produtos-nao-encontrados';
export const SALES_REPORT_RISK_ANALYSIS_PAGE_URL = '/relatorios/vendas/analise-de-risco';
export const SALES_REPORT_POINT_OF_SALE_CONVERSION_PAGE_URL = '/relatorios/vendas/conversao-pdv';
export const SALES_REPORT_INVOICE_PRODUCT_QUERY_PAGE_URL = '/relatorios/vendas/nota-fiscal/consulta-produto';
export const SALES_REPORT_INVOICE_OPERATION_PAGE_URL = '/relatorios/vendas/nota-fiscal/operacao';
export const SALES_REPORT_INVOICE_CLIENT_PAGE_URL = '/relatorios/vendas/nota-fiscal/cliente';
export const SALES_REPORT_INVOICE_EVOLUTION_PAGE_URL = '/relatorios/vendas/nota-fiscal/evolucao';

// FINANÇAS

// Competência
export const COMPETENCE_PAGE_URL = '/financas/competencia';
export const COMPETENCE_LIST_PAGE_URL = '/financas/competencia/lista';
export const COMPETENCE_DETAILS_PAGE_URL = (id: string) => `/financas/competencia/${id}`;
export const COMPETENCE_EDIT_PAGE_URL = (id: string) => `/financas/competencia/lista/edita/${id}`;
export const COMPETENCE_REMOVE_PAGE_URL = (id: string) => `/financas/competencia/lista/remove/${id}`;

// Caixa e Banco
export const CASH_BANK_PAGE_URL = '/financas/caixa';
export const CASH_BANK_LIST_PAGE_URL = '/financas/caixa/lista';
export const CASH_BANK_NEW_PAGE_URL = '/financas/caixa/lista/novo';
export const CASH_BANK_EDIT_PAGE_URL = (id: string) => `/financas/caixa/lista/edita/${id}`;
export const CASH_BANK_REMOVE_PAGE_URL = (id: string) => `/financas/caixa/lista/remove/${id}`;

// Informações sobre Parcela
export const INSTALLMENT_INFO_PAGE_URL = (id: string) => `/financas/parcela/${id}`;

// Conta a Pagar
export const ACCOUNTS_PAYABLE_PAGE_URL = '/financas/contas-a-pagar';
export const ACCOUNTS_PAYABLE_LIST_PAGE_URL = '/financas/contas-a-pagar/lista';
export const ACCOUNTS_PAYABLE_NEW_PAGE_URL = '/financas/contas-a-pagar/novo';
export const ACCOUNTS_PAYABLE_EDIT_PAGE_URL = (id: string) => `/financas/contas-a-pagar/lista/edita/${id}`;
export const ACCOUNTS_PAYABLE_REMOVE_PAGE_URL = (id: string) => `/financas/contas-a-pagar/lista/remove/${id}`;

// Conta a Receber
export const ACCOUNTS_RECEIVABLE_PAGE_URL = '/financas/contas-a-receber';
export const ACCOUNTS_RECEIVABLE_LIST_PAGE_URL = '/financas/contas-a-receber/lista';
export const ACCOUNTS_RECEIVABLE_NEW_PAGE_URL = '/financas/contas-a-receber/novo';
export const ACCOUNTS_RECEIVABLE_EDIT_PAGE_URL = (id: string) => `/financas/contas-a-receber/lista/edita/${id}`;
export const ACCOUNTS_RECEIVABLE_REMOVE_PAGE_URL = (id: string) => `/financas/contas-a-receber/lista/remove/${id}`;

// Repasse a Condomínio
export const COMMUNITY_SETTLEMENT_PAGE_URL = '/financas/repasse-condominio';
export const COMMUNITY_SETTLEMENT_NEW_PAGE_URL = '/financas/repasse-condominio/novo';
export const COMMUNITY_SETTLEMENT_EDIT_PAGE_URL = (id: string) => `/financas/repasse-condominio/edita/${id}`;
export const COMMUNITY_SETTLEMENT_DETAILS_PAGE_URL = (id: string) => `/financas/repasse-condominio/${id}`;

// Extrato Bancário
export const BANK_STATEMENT_PAGE_URL = '/financas/extrato-bancario';
export const BANK_STATEMENT_DETAIL_PAGE_URL = (id: string) => `/financas/extrato-bancario/${id}`;
export const BANK_STATEMENT_LIST_PAGE_URL = '/financas/extrato-bancario/lista';
export const BANK_STATEMENT_NEW_PAGE_URL = '/financas/extrato-bancario/novo';

// Relatório de Finanças
export const FINANCIAL_REPORT_PAGE_URL = '/relatorios/financas';
export const FINANCIAL_REPORT_BALANCE_SHEET_PAGE_URL = '/relatorios/financas/geral/saldos-por-conta';
export const FINANCIAL_REPORT_DRE_PAGE_URL = '/relatorios/financas/geral/dre';
export const FINANCIAL_REPORT_POINT_OF_SALE_RESULT_PAGE_URL = '/relatorios/financas/geral/resultado-por-pdv';
export const FINANCIAL_REPORT_CASH_FLOW_PAGE_URL = '/relatorios/financas/geral/fluxo-caixa';
export const FINANCIAL_REPORT_CASH_CATEGORY_PAGE_URL = '/relatorios/financas/caixa/categoria';
export const FINANCIAL_REPORT_CASH_CLIENT_PAGE_URL = '/relatorios/financas/caixa/cliente';
export const FINANCIAL_REPORT_ACCOUNTS_PAYABLE_PAGE_URL = '/relatorios/financas/conta/a-pagar';
export const FINANCIAL_REPORT_ACCOUNTS_RECEIVABLE_PAGE_URL = '/relatorios/financas/conta/a-receber';
export const FINANCIAL_REPORT_RECEIPTS_PAGE_URL = '/relatorios/financas/conta/recebimento';

// CADASTROS

// Condomínio
export const CONDOMINIUM_PAGE_URL = '/cadastros/parceiros/condominio';
export const CONDOMINIUM_DETAIL_PAGE_URL = (id: string) => `/cadastros/parceiros/condominio/${id}`;
export const CONDOMINIUM_LIST_PAGE_URL = '/cadastros/parceiros/condominio/lista';
export const CONDOMINIUM_NEW_PAGE_URL = '/cadastros/parceiros/condominio/novo';
export const CONDOMINIUM_EDIT_PAGE_URL = (id: string) => `/cadastros/parceiros/condominio/edita/${id}`;
export const CONDOMINIUM_REMOVE_PAGE_URL = (id: string) => `/cadastros/parceiros/condominio/lista/remove/${id}`;

// Fornecedor
export const SUPPLIER_PAGE_URL = '/cadastros/parceiros/fornecedor';
export const SUPPLIER_DETAIL_PAGE_URL = (id: string) => `/cadastros/parceiros/fornecedor/${id}`;
export const SUPPLIER_LIST_PAGE_URL = '/cadastros/parceiros/fornecedor/lista';
export const SUPPLIER_NEW_PAGE_URL = '/cadastros/parceiros/fornecedor/novo';
export const SUPPLIER_EDIT_PAGE_URL = (id: string) => `/cadastros/parceiros/fornecedor/lista/edita/${id}`;
export const SUPPLIER_REMOVE_PAGE_URL = (id: string) => `/cadastros/parceiros/fornecedor/lista/remove/${id}`;

// Ponto de Venda
export const POINT_OF_SALE_PAGE_URL = '/cadastros/operacao/ponto-de-venda';
export const POINT_OF_SALE_DETAIL_PAGE_URL = (id: string) => `/cadastros/operacao/ponto-de-venda/${id}`;
export const POINT_OF_SALE_LIST_PAGE_URL = '/cadastros/operacao/ponto-de-venda/lista';
export const POINT_OF_SALE_NEW_PAGE_URL = '/cadastros/operacao/ponto-de-venda/novo';
export const POINT_OF_SALE_EDIT_PAGE_URL = (id: string) => `/cadastros/operacao/ponto-de-venda/edita/${id}`;
export const POINT_OF_SALE_REMOVE_PAGE_URL = (id: string) => `/cadastros/operacao/ponto-de-venda/lista/remove/${id}`;

// Cliente
export const CLIENT_PAGE_URL = '/cadastros/parceiros/cliente';
export const CLIENT_DETAIL_PAGE_URL = (id: string) => `/cadastros/parceiros/cliente/${id}`;
export const CLIENT_LIST_PAGE_URL = '/cadastros/parceiros/cliente/lista';
export const CLIENT_NEW_PAGE_URL = '/cadastros/parceiros/cliente/novo';
export const CLIENT_EDIT_PAGE_URL = (id: string) => `/cadastros/parceiros/cliente/lista/edita/${id}`;
export const CLIENT_REMOVE_PAGE_URL = (id: string) => `/cadastros/parceiros/cliente/lista/remove/${id}`;

export const CLIENT_FEEDBACK_PAGE_URL = '/crm/pesquisa-satisfacao';
export const CLIENT_FEEDBACK_LIST_PAGE_URL = '/crm/pesquisa-satisfacao/lista';
export const CLIENT_FEEDBACK_NEW_PAGE_URL = '/crm/pesquisa-satisfacao/lista/novo';
export const CLIENT_FEEDBACK_EDIT_PAGE_URL = (id: string) => `/crm/pesquisa-satisfacao/lista/edita/${id}`;
export const CLIENT_FEEDBACK_RESULTS_PAGE_URL = (id: string) =>
  `/crm/pesquisa-satisfacao/lista?pesquisa=${encodeURIComponent(id)}`;

// Funcionário
export const EMPLOYEE_PAGE_URL = '/cadastros/parceiros/funcionario';
export const EMPLOYEE_DETAIL_PAGE_URL = (id: string) => `/cadastros/parceiros/funcionario/${id}`;
export const EMPLOYEE_LIST_PAGE_URL = '/cadastros/parceiros/funcionario/lista';
export const EMPLOYEE_NEW_PAGE_URL = '/cadastros/parceiros/funcionario/novo';
export const EMPLOYEE_EDIT_PAGE_URL = (id: string) => `/cadastros/parceiros/funcionario/lista/edita/${id}`;
export const EMPLOYEE_REMOVE_PAGE_URL = (id: string) => `/cadastros/parceiros/funcionario/lista/remove/${id}`;

// Terminal
export const TERMINAL_PAGE_URL = '/cadastros/operacao/terminal';
export const TERMINAL_LIST_PAGE_URL = '/cadastros/operacao/terminal/lista';
export const TERMINAL_EDIT_PAGE_URL = (id: string) => `/cadastros/operacao/terminal/edita/${id}`;
export const TERMINAL_REMOVE_PAGE_URL = (id: string) => `/cadastros/operacao/terminal/lista/remove/${id}`;

// PREFERENCIAS

// Preferências Gerais
export const PREFERENCES_PAGE_URL = '/preferencias';
export const COMPANY_LIST_PAGE_URL = '/preferencias/empresas/lista';
export const COMPANY_NEW_PAGE_URL = '/preferencias/empresas/novo';
export const COMPANY_EDIT_PAGE_URL = (id: string) => `/preferencias/empresas/edita/${id}`;
export const DIGITAL_CERTIFICATE_SETTINGS_PAGE_URL = '/preferencias/certificado-digital';
export const COMMUNICATION_PROVIDERS_PAGE_URL = '/preferencias/comunicacao';
export const SEPARATION_SETTINGS_PAGE_URL = '/preferencias/separacao';
export const FILE_UPLOAD_PAGE_URL = '/preferencias/arquivos';
export const TAX_SCENARIO_SETTINGS_PAGE_URL = '/preferencias/cenario-fiscal';
export const NFE_SETTINGS_PAGE_URL = '/preferencias/nfe';
export const USER_INTERFACE_PAGE_URL = '/preferencias/interface';
export const BUY_ORDERS_SETTINGS_PAGE_URL = '/preferencias/ordens-compra';
export const SALES_REQUESTS_SETTINGS_PAGE_URL = '/preferencias/ordens-venda';
export const SALES_RISK_ANALYSIS_SETTINGS_PAGE_URL = '/preferencias/analise-de-risco';
export const NOTIFICATIONS_SETTINGS_PAGE_URL = '/preferencias/notificacoes';
export const TAX_SCENARIO_PAGE_URL = '/preferencias/cenario-fiscal';
export const PREFERENCES_ACCOUNT_PAGE_URL = '/preferencias/conta';
export const PREFERENCES_CONVERSION_UNIT_PAGE_URL = '/preferencias/unidades-conversao';

// Modelos de Etiquetas
export const TAG_TEMPLATE_PAGE_URL = '/preferencias/modelo-etiqueta';
export const TAG_TEMPLATE_LIST_PAGE_URL = '/preferencias/modelo-etiqueta/lista';
export const TAG_TEMPLATE_NEW_PAGE_URL = '/preferencias/modelo-etiqueta/novo';
export const TAG_TEMPLATE_EDIT_PAGE_URL = (id: string) => `/preferencias/modelo-etiqueta/editar/${id}`;

// Produtos
export const PRODUCTS_DETAILS_PAGE_URL = '/preferencias/cadastros/produtos/atributos';
export const PRODUCTS_TAGS_PAGE_URL = '/preferencias/marcador/PRODUCT/lista';
export const PRODUCTS_BRANDS_PAGE_URL = '/preferencias/marcas/lista';

// Suprimentos / Inventário
export const INVENTORY_DEPOSITS_PAGE_URL = '/preferencias/estoque-central';
export const INVENTORY_SETTINGS_PAGE_URL = '/preferencias/suprimentos/estoque';
export const BUY_ORDERS_TAGS_PAGE_URL = '/preferencias/marcador/BUY_ORDER/lista';
export const OPERATIONS_ORIGIN_PAGE_URL = '/preferencias/natureza-de-operacao/entrada/lista';
export const INCOME_TAX_RECEIPT_TAGS_PAGE_URL = '/preferencias/marcador/NFE_IN/lista';
export const AUTOMATIONS_PAGE_URL = '/preferencias/automacoes';
export const AUTOMATIC_REPLENISHMENT_EXECUTIONS_PAGE_URL = (id: string) =>
  `${AUTOMATIONS_PAGE_URL}/reposicao-automatica/${id}`;
export const AUTOMATIC_PICKLIST_EXECUTIONS_PAGE_URL = (id: string) =>
  `${AUTOMATIONS_PAGE_URL}/picklist-automatica/${id}`;

// Vendas
export const POINTS_OF_SALE_SETTINGS_PAGE_URL = '/preferencias/vendas/pdv';
export const SALES_TAGS_PAGE_URL = '/preferencias/marcador/SALES_ORDER/lista';
export const OUTCOME_TAX_RECEIPT_TAGS_PAGE_URL = '/preferencias/marcador/NFE_OUT/lista';
export const TAX_OPERATIONS_ORIGIN_OUT_PAGE_URL = '/preferencias/natureza-de-operacao/saida/lista';
export const TAX_OPERATIONS_ORIGIN_IN_PAGE_URL = '/preferencias/natureza-de-operacao/entrada/lista';
export const SEPARATION_TAGS_PAGE_URL = '/preferencias/marcador/PICKING/lista';

// Finanças
export const BANKS_PAGE_URL = '/preferencias/financas/bancos';
export const INCOME_OUTCOME_CATEGORIES_PAGE_URL = '/preferencias/financas/categorias-financeiras';
export const RECEIVE_METHODS_PAGE_URL = '/preferencias/financas/formas-recebimento';
export const PAYMENT_METHODS_PAGE_URL = '/preferencias/financas/formas-pagamento';
export const BANK_ACCOUNTS_PAGE_URL = '/preferencias/financas/contas-bancarias';
export const ACQUIRERS_PAGE_URL = '/preferencias/financas/adquirentes';
export const ACQUIRERS_LIST_PAGE_URL = '/preferencias/financas/adquirentes/lista';
export const FINANCIAL_ACCOUNTS_PAGE_URL = '/preferencias/financas/contas-financeiras';
export const CASH_TAGS_PAGE_URL = '/preferencias/marcador/CASH_FLOW/lista';
export const BILLS_TO_PAY_TAGS_PAGE_URL = '/preferencias/marcador/BILL_PAY/lista';
export const BILLS_TO_RECEIVE_TAGS_PAGE_URL = '/preferencias/marcador/BILL_RECEIVE/lista';

// Cadastros Fiscais
export const CFOP_CODES_PAGE_URL = '/preferencias/cadastros/fiscal/cfop';
export const CEST_CODES_PAGE_URL = '/preferencias/cadastros/fiscal/cest';
export const NCM_CODES_PAGE_URL = '/preferencias/cadastros/fiscal/ncm';

export const USER_ROLES_PAGE_URL = '/preferencias/grupos-permissao';
export const USER_ROLES_LIST_PAGE_URL = '/preferencias/grupos-permissao/lista';

// Webhook Events
export const WEBHOOK_EVENTS_PAGE_URL = '/preferencias/eventos-webhook';

// ESPAÇO CONTADOR
export const ACCOUNTANT_SPACE_PAGE_URL = '/espaco-contador';
export const ACCOUNTANT_DASHBOARD_PAGE_URL = '/espaco-contador/dashboard';
export const ACCOUNTANT_ACCESS_MANAGEMENT_PAGE_URL = '/espaco-contador/acessos';
export const ACCOUNTANT_INVITE_MANAGEMENT_PAGE_URL = '/espaco-contador/convites';

// ESPACO GESTOR
export const MANAGER_SPACE_PAGE_URL = '/espaco-gestor';
export const MANAGER_DASHBOARD_PAGE_URL = '/espaco-gestor/dashboard';

// USUÁRIOS DO SISTEMA
export const SYSTEM_USER_DASHBOARD_PAGE_URL = '/inicio/indice';

// COMUNICADOS
export const ANNOUNCEMENTS_PAGE_URL = '/inicio/comunicado';
export const ANNOUNCEMENT_REPORT_PAGE_URL = (id: string) => `/inicio/comunicado/relatorio/${id}`;
